import { WIDE_SHELL_MIN_WIDTH } from '@/chat/useShellWidth';
import { useChatContext } from '@/chat/ChatContext';
import { ChipAwareMarkdown } from '@/markdown/chips';
import type { ProductJustificationSection } from '@/types/chat';


export function ProductJustificationView({
  section,
}: {
  section: ProductJustificationSection;
}): JSX.Element | null {
  const { payload, shellWidth } = useChatContext();
  const items = (section.items ?? []).filter((item) =>
    payload.products.some((product) => product.slug === item.sku),
  );

  if (items.length === 0) return null;
  // Default to the wide variant before the first measurement arrives —
  // most chat mounts are wide, and falling back to bullet+indent is the
  // less surprising default if the shell width is unknown.
  const isWide = shellWidth == null || shellWidth >= WIDE_SHELL_MIN_WIDTH;
  const listVariant = isWide ? 'is-wide' : 'is-narrow';
  return (
    <section className="tw-space-y-3">
      {section.title && (
        <h3 className="tw-font-serif tw-text-[15.5px] tw-font-bold tw-text-cal-ink">
          {section.title}
        </h3>
      )}
      {section.intro_md && (
        <ChipAwareMarkdown
          source={section.intro_md}
          className="tw-text-[14px] tw-text-cal-ink-soft tw-leading-relaxed"
        />
      )}
      <ul className={`cal-justif-list ${listVariant} tw-space-y-3`}>
        {items.map((item, i) => (
          <li
            key={`${item.sku}-${i}`}
            className="tw-text-[14px] tw-text-cal-ink-soft tw-leading-relaxed"
          >
            <ChipAwareMarkdown
              source={item.body_md}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
